import { cn } from '@/shared/utils/styling';
import { cva, type VariantProps } from 'class-variance-authority';

const skeletonVariants = cva('animate-pulse rounded-full w-[5rem]', {
  variants: {
    variant: {
      small: 'h-[1.6rem]',
      medium: 'h-[2.4rem]',
      large: 'h-[4.2rem]',
      avatar: 'aspect-square',
    },
    backgroundColor: {
      default: 'bg-accent',
      primary: 'bg-primary',
      white: 'bg-white',
      tertiary: 'bg-tertiary',
    },
  },
  defaultVariants: {
    variant: 'medium',
    backgroundColor: 'default',
  },
});

export interface SkeletonProps
  extends React.ComponentProps<'div'>,
    VariantProps<typeof skeletonVariants> {}

function Skeleton({
  className,
  variant,
  backgroundColor,
  ...props
}: SkeletonProps) {
  return (
    <div
      data-slot="skeleton"
      className={cn(skeletonVariants({ variant, backgroundColor }), className)}
      {...props}
    />
  );
}

export { Skeleton };
